import React, { Component } from 'react';
import { Link } from 'react-router';
import { Form, FormField, Input, Button, Translate } from '$common';
import Layout from './layout';



export default class ResetPassword extends Component {
  render() {
    const { onSubmit, errors } = this.props;

    return (
      <Layout
        title={Translate.get('reset_my_password')}
        type={'login'}
      >
        <Form onSubmit={onSubmit} errors={errors}>
          <FormField name="password" label={Translate.get('new_password')}>
            <Input type="password" required />
          </FormField>
          <FormField name="passwordConfirmation" label={Translate.get('new_password_again')}>
            <Input type="password" required />
          </FormField>
          <Button type="success" submit block>{Translate.get('reset_my_password')}</Button>
        </Form>
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/reset-password.js